module.exports = __webpack_public_path__ + "img/logo-min.bfc774a.bfc774ab.png";